import axios from './axios.service'

const method = 'contacts'

class ContactService {
  async index(queryData) {
    try {
      const response = await axios.get(`/${method}`, {
        params: { ...queryData }
      })
      return response.data
    } catch (error) {
      return error
    }
  }

  async show(id) {
    try {
      const response = await axios({
        method: 'get',
        url: `/${method}/${id}`
      })
      return response
    } catch (error) {
      console.log(error)
    }
  }

  async delete(rowClicked) {
    try {
      const response = await axios.delete(`/${method}/${rowClicked.id}`)
      return response
    } catch (error) {
      return error
    }
  }

  async forceDelete(id, data) {
    try {
      const response = await axios.delete(`/lgpd/${method}/${id}`, {
        params: { ...data }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async update(id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${method}/${id}`,
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }

  async updateArrayContact(data) {
    try {
      const response = await axios({
        method: 'put',
        url: '/arrayupdate/contacts',
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }
}

export default new ContactService()
